package com.klantenstop.web.pages.admin.companies.manage

import com.klantenstop.web.data.repos.CategoryRepo
import com.klantenstop.web.data.repos.CompanyRepo
import com.materialkobweb.utils.ViewModel
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext

class ManageCompanyViewModel(
    private val companyId: String?,
    private val companyRepo: CompanyRepo = CompanyRepo,
    private val categoryRepo: CategoryRepo = CategoryRepo
) : ViewModel(), ManageCompanyContract {

    private val _state = MutableStateFlow(ManageCompanyContract.State())
    override val state: StateFlow<ManageCompanyContract.State> = _state.asStateFlow()

    private val _effect = MutableSharedFlow<ManageCompanyContract.Effect>()
    override val effect: SharedFlow<ManageCompanyContract.Effect> = _effect.asSharedFlow()

    init {
        sendIntent(ManageCompanyContract.Intent.LoadCategories)
        companyId?.let {
            sendIntent(ManageCompanyContract.Intent.LoadCompany(it))
        }
    }

    override fun sendIntent(intent: ManageCompanyContract.Intent) = coroutineScope.launch {
        when (intent) {
            is ManageCompanyContract.Intent.LoadCompany -> loadCompany(intent.companyId)
            is ManageCompanyContract.Intent.LoadCategories -> loadCategories()
            is ManageCompanyContract.Intent.UpdateName -> updateName(intent.name)
            is ManageCompanyContract.Intent.UpdateDescription -> updateDescription(intent.description)
            is ManageCompanyContract.Intent.UpdateEmail -> updateEmail(intent.email)
            is ManageCompanyContract.Intent.UpdatePhone -> updatePhone(intent.phone)
            is ManageCompanyContract.Intent.UpdateWebsite -> updateWebsite(intent.website)
            is ManageCompanyContract.Intent.UpdateCategories -> updateCategories(intent.categories)
            is ManageCompanyContract.Intent.UpdateStatus -> updateStatus(intent.status)
            is ManageCompanyContract.Intent.UpdateLogo -> updateLogo(intent.logoUrl)
            is ManageCompanyContract.Intent.SaveCompany -> saveCompany()
        }
    }

    override fun emitEffect(effect: ManageCompanyContract.Effect) = coroutineScope.launch {
        _effect.emit(effect)
    }

    override fun updateState(block: (ManageCompanyContract.State) -> ManageCompanyContract.State) {
        _state.update(block)
    }

    private suspend fun loadCompany(companyId: String) = withContext(Dispatchers.Default) {
        updateState { it.copy(isLoading = true) }

        // TODO: Implement load company logic via companyRepo
        // val company = companyRepo.getCompanyById(companyId)
        // if (company != null) {
        //     updateState {
        //         it.copy(
        //             company = company,
        //             name = company.name,
        //             description = company.description ?: "",
        //             email = company.email ?: "",
        //             phone = company.phone ?: "",
        //             website = company.website ?: "",
        //             selectedCategories = company.categories,
        //             selectedStatus = company.status,
        //             logoUrl = company.logoUrl,
        //             isLoading = false
        //         )
        //     }
        // } else {
        //     emitEffect(ManageCompanyContract.Effect.ShowError("Company not found"))
        //     emitEffect(ManageCompanyContract.Effect.NavigateBack)
        // }

        updateState { it.copy(isLoading = false) }
    }

    private suspend fun loadCategories() = withContext(Dispatchers.Default) {
        val categories = categoryRepo.getCategories()
        updateState { it.copy(availableCategories = categories) }
    }

    private fun updateName(name: String) {
        updateState { it.copy(name = name) }
    }

    private fun updateDescription(description: String) {
        updateState { it.copy(description = description) }
    }

    private fun updateEmail(email: String) {
        updateState { it.copy(email = email) }
    }

    private fun updatePhone(phone: String) {
        updateState { it.copy(phone = phone) }
    }

    private fun updateWebsite(website: String) {
        updateState { it.copy(website = website) }
    }

    private fun updateCategories(categories: List<com.klantenstop.web.data.models.domain.Category>) {
        updateState { it.copy(selectedCategories = categories) }
    }

    private fun updateStatus(status: com.klantenstop.web.data.models.domain.Status) {
        updateState { it.copy(selectedStatus = status) }
    }

    private fun updateLogo(logoUrl: String) {
        updateState { it.copy(logoUrl = logoUrl) }
    }

    private suspend fun saveCompany() {
        updateState { it.copy(isSaving = true) }

        // TODO: Implement save/update company logic
        // val currentState = state.value
        // val success = if (companyId != null) {
        //     companyRepo.updateCompany(
        //         id = companyId,
        //         name = currentState.name,
        //         description = currentState.description,
        //         email = currentState.email,
        //         phone = currentState.phone,
        //         website = currentState.website,
        //         categories = currentState.selectedCategories,
        //         status = currentState.selectedStatus,
        //         logoUrl = currentState.logoUrl
        //     )
        // } else {
        //     companyRepo.createCompany(
        //         name = currentState.name,
        //         description = currentState.description,
        //         email = currentState.email,
        //         phone = currentState.phone,
        //         website = currentState.website,
        //         categories = currentState.selectedCategories,
        //         status = currentState.selectedStatus,
        //         logoUrl = currentState.logoUrl
        //     )
        // }
        //
        // if (success) {
        //     emitEffect(ManageCompanyContract.Effect.ShowSuccess("Company saved successfully"))
        //     emitEffect(ManageCompanyContract.Effect.NavigateBack)
        // } else {
        //     emitEffect(ManageCompanyContract.Effect.ShowError("Failed to save company"))
        // }

        updateState { it.copy(isSaving = false) }
    }
}

